export const GET_PROFILO_ARIANNA = "GET_PROFILO_ARIANNA"
export const GET_PROFILO_ARIANNA_SUCCESS = "GET_PROFILO_ARIANNA_SUCCESS"

export const PATCH_PROFILO_ARIANNA = "PATCH_PROFILO_ARIANNA"

export const GET_SCREENING_RESULT = "GET_SCREENING_RESULT"
export const GET_SCREENING_RESULT_SUCCESS = "GET_SCREENING_RESULT_SUCCESS"

export const GET_ADHESION_STATUS = "GET_ADHESION_STATUS"
export const GET_ADHESION_STATUS_SUCCESS = "GET_ADHESION_STATUS_SUCCESS"

export const GET_INVITE_REMINDER = "GET_INVITE_REMINDER"
export const GET_INVITE_REMINDER_SUCCESS = "GET_INVITE_REMINDER_SUCCESS"

export const POST_APPOINTMENT_CANCEL = "POST_APPOINTMENT_CANCEL"

export const POST_APPOINTMENT_CONFIRM = "POST_APPOINTMENT_CONFIRM"
export const POST_APPOINTMENT_CONFIRM_SUCCESS = "POST_APPOINTMENT_CONFIRM_SUCCESS"



export const RESET_SCREENING_STATE = "RESET_SCREENING_STATE"